// Apolo IDE — useOutputsCollapsed.
//
// Collapse state for the right "Saídas/Canvas" rail in the Code chat, persisted
// in localStorage `apolo:outputs:collapsed` (mirrors the CodeSidebar pattern at
// `apolo:sidebar:collapsed`). Collapsing the rail frees its width back to the
// chat column so the message area gets wider — the feature itself never
// disappears (collapsed = slim handle that re-expands in one click).

import { useCallback, useEffect, useState } from 'react';

export const LS_OUTPUTS_COLLAPSED = 'apolo:outputs:collapsed';

export function readOutputsCollapsed() {
  if (typeof window === 'undefined') return false;
  try {
    const saved = window.localStorage.getItem(LS_OUTPUTS_COLLAPSED);
    return saved === null ? window.localStorage.getItem('apolo:workbench:v2') !== '0' : saved === '1';
  } catch {
    return false;
  }
}

export function writeOutputsCollapsed(value) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(LS_OUTPUTS_COLLAPSED, value ? '1' : '0');
  } catch {
    // ignore — private mode / quota
  }
}

/** @returns {[boolean, import('react').Dispatch<import('react').SetStateAction<boolean>>, () => void]} */
export function useOutputsCollapsed() {
  const [collapsed, setCollapsed] = useState(readOutputsCollapsed);

  useEffect(() => {
    writeOutputsCollapsed(collapsed);
  }, [collapsed]);

  const toggle = useCallback(() => setCollapsed((v) => !v), []);

  return [collapsed, setCollapsed, toggle];
}
